<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container
    :use-return="true"
    @back="back"
  >
    <template #title>
      <div class="text-h3">
        {{ $t('ShopType') }}
      </div>
    </template>

    <div
      class="mt-4 py-4"
      style="display: grid;
      grid-template-columns:repeat(auto-fill,minmax(160px,1fr));width: 100%;
    grid-gap: 12px;"
    >
      <v-card
        v-for="type in storeType"
        :key="type.id"
        :class="selectedStoreTypeId===type.id?'yellow lighten-4 black--text':''"
        class="pa-4"
        elevation="0"
        @click="selectedStoreTypeId=type.id;next(selectedStoreTypeId)"
      >
        <div
          class="d-flex align-center justify-center"
          style="height: 100%"
        >
          <div style="position: absolute;left: 16px">
            <v-img
              :src="require('@/assets/SaaSImg/type/'+type.icon)"
              width="24"
            />
          </div>
          <div class="text-h4 ml-4">
            {{ type.title }}
          </div>
        </div>
      </v-card>
    </div>
  </saa-s-child-page-container>
</template>

<script>
import { getCurrentSaaSOrderInfo, selectStoreType, storeType } from '@/views/SaaS/SaaSGuide'
import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'

export default {
  name: 'SelectType',
  components: {
    SaaSChildPageContainer
  },
  data: function () {
    return {
      storeType,
      selectedStoreTypeId: getCurrentSaaSOrderInfo().storeType
    }
  },
  methods: {
    back () {
      this.$router.push({ name: 'SaaS' })
    },
    next () {
      selectStoreType(this.selectedStoreTypeId)
      this.$router.push({ name: 'choose-chain' })
    }
  }
}
</script>

<style scoped>

</style>
